<script setup lang="ts">
const props = defineProps<{
  title: string
  image?: {
    src: string
    alt?: string
  }
}>()
</script>

<template>
  <ApplicationPageHeaderImage :title="props.title" class="relative z-10" :image="props.image" />
  <slot />
</template>
